import { useHistory, useLocation } from 'react-router-dom';

const useReactRouterContext = () => ({
  history: useHistory(),
  location: useLocation(),
});

export default useReactRouterContext;
